const c = (t) => t === "" ? t : t[0].toUpperCase() + t.slice(1), n = (t) => !!t && !!t.shadowRoot && !!t.attachShadow, a = () => {
  var o;
  const t = document.activeElement;
  return n(t) ? ((o = t == null ? void 0 : t.shadowRoot) == null ? void 0 : o.activeElement) || void 0 : t || void 0;
}, s = (t, o = "log") => {
  console[o](
    "%c IDS ",
    "background: #21F5A8; color: #3A1C46; font-weight:bold;",
    t
  );
}, i = (t, o, r = "__") => t ? `${t}${r}${o}` : void 0, u = (t, o = []) => {
  let r = t;
  return o.forEach((e) => {
    r = r.split(e.name).join(e.value);
  }), r;
}, d = (t) => Array.isArray(t) ? t : t !== void 0 ? [t] : [], l = (t) => {
  const o = String(t);
  return /^\d+$/.test(o) ? `${o}px` : o;
};
export {
  c as capitalizeFirstLetter,
  a as getActiveElement,
  n as hasShadowDom,
  s as idsLogger,
  i as propagateTestid,
  u as stringReplacer,
  d as toArray,
  l as toCSSLengthValue
};
